var o = /* @__PURE__ */function (E) {
    return E.DOWN = "ArrowDown", E.UP = "ArrowUp", E.RIGHT = "ArrowRight", E.LEFT = "ArrowLeft", E;
  }(o || {}),
  A = /* @__PURE__ */function (E) {
    return E.ESCAPE = "Escape", E.TAB = "Tab", E.ENTER = "Enter", E;
  }(A || {});
export { A as E, o as a };